<template>
    <section class="gardenManagementPage">
      <!-- <SearchForm class="dis-flex flex-x-between flex-y-center">
        <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px">
          <el-form-item>
            <el-input v-model.trim="searchForm.videoTitle" placeholder="请输入文件名称" />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.catId"
              placeholder="请选择视频分类"
              clearable
              @clear="handleClearType"
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.catName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="dayTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd"
              data-format="yyyy-MM-dd"
              @change="selectTime"
            >
            </el-date-picker>
          </el-form-item>
  
          <el-form-item>
            <el-button @click="cancelData">重置</el-button>
            <el-button type="primary" @click="queryPxVideoPagepx">搜 索</el-button>
          </el-form-item>
        </el-form>
        <el-button type="success" @click="addVideo" class="turnBule">添加文件</el-button>
      </SearchForm> -->
  
      <TableContainer title="">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          border
          :header-cell-style="tabHeader"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column prop="id" label="序号" min-width="20" />
   
          <el-table-column prop="organizationName" label="所属部门" min-width="40" />
          <!-- <el-table-column prop="videoImg" label="视频缩略图" min-width="60">
            <template slot-scope="scope">
              <div class="p-r" @click="showVideo(scope.row)">
                <img :src="scope.row.videoImg" width="60" height="60" />
                <i
                  class="el-icon-video-play f-32 p-a col-f"
                  style="top: 50%; left: 50%; transform: translate(-50%, -50%)"
                ></i>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="videoState" label="文件状态" min-width="30">
            <template slot-scope="scope">
              <el-tag type="danger">{{ scope.row.videoState == "0" ? "已上架" : "已下架" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="catName" label="文件分类" min-width="40" />
  
          <el-table-column prop="videoTitle" label="文件名称(可点击访问)" min-width="60" >
            <template slot-scope="scope">
              <a :href="scope.row.videoUrl" target="_blank" style="color:#0275d8">{{scope.row.videoTitle}}</a>
  
            </template>
          </el-table-column>
  

          <el-table-column prop="videoState" label="其它" min-width="60">
            <template slot-scope="scope">
              <div class="dis-flex flex-x-start flex-y-center"><el-tag type="info">培训形式</el-tag><p style="margin-left:10px">{{ scope.row.pxType||'--'}}</p></div>
              <div class="dis-flex flex-x-start flex-y-center m-top10"><el-tag type="info">培训老师</el-tag><p style="margin-left:10px">{{ scope.row.pxName||'--'}}</p></div>
              <div class="dis-flex flex-x-start flex-y-center m-top10"><el-tag type="info">培训时间</el-tag><p style="margin-left:10px">{{ scope.row.pxTime||'--'}}</p></div>
              <div class="dis-flex flex-x-start flex-y-center m-top10"><el-tag type="info">考核形式</el-tag><p style="margin-left:10px">{{ scope.row.pxCheck||'--'}}</p></div>
              
            </template>
          </el-table-column>
  
          <el-table-column prop="createTime" label="发布时间" min-width="60" />
  
          <el-table-column width="250" label="操作">
            <template slot-scope="scope">
              <el-button type="text" class="textOrange" @click="updatePxVideo(scope.row)">恢复上架</el-button>
              <!-- <el-button type="text" class="textOrange" @click="editorClick(scope.row)"
                >编辑</el-button
              >
              <el-button type="text" class="textOrange" @click="delteFormClick(scope.row)"
                >删除</el-button
              >
              <el-button type="text" class="textOrange" @click="uploadFormClick(scope.row)"
                >导出</el-button> -->
              
            </template>
          </el-table-column>
        </el-table>
        <GPagination
          v-show="total > 0"
          ref="ref_GPagination"
          :total="total"
          :page.sync="searchForm.page"
          :size.sync="searchForm.size"
          @pagination="queryPxVideoPagepx"
        />
      </TableContainer>
  
      <!-- <Tinymce :height="200" v-model="tiny.value"></Tinymce> -->
  
      <!-- <button @click="buttonClick">提交</button> -->
  
      <el-dialog :visible.sync="themeDialogs.visible" width="800px">
        <div class="dis-flex flex-x-center">
          <video
            :src="video"
            poster=""
            type="video/mp4,audio/mp3"
            controls="controls"
            preload="auto"
            style="display: block; width: 700px; height: 500px"
          >
            您的浏览器不支持视频播放
          </video>
        </div>
      </el-dialog>
      <!-- 导出s -->
      <GDialog
        :dialog.sync="scoreDialog"
        @btnSure="scoreSubmitThemeForm()"
        @btnClose="resetThemeForm()"
        width="20%"
        :showCloseBtn="true"
        :showFooter="false"
      >
        <el-form
          ref="ref_themeForm"
          @submit.native.prevent
          class="dis-flex flex-dir-column flex-x-center flex-y-center"
        >
          <el-form-item>
            <p>确认导出【{{ item.videoTitle }}】学习数据?</p>
          </el-form-item>
  
          <download-excel
            class="export-excel-wrapper"
            :data="jsonData"
            :name="item.videoTitle + '学习数据.xlsx'"
          >
            <el-button @click="down" type="primary" style="margin-bottom: 30px"
              >导出</el-button
            >
          </download-excel>
        </el-form>
      </GDialog>
      <!-- 导出e -->
  
      <!-- 新增/编辑分类s -->
      <GDialog
        :dialog.sync="catDialog"
        @btnSure="catSubmitThemeForm()"
        @btnClose="catresetThemeForm()"
        width="40%"
        :showCloseBtn="false"
        :showFooter="true"
      >
        <el-form ref="ref_themeForm" label-width="80px" @submit.native.prevent>
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="文件标题" label-width="80px" class="t-c">
              <el-input
                v-model="pxParmas.videoTitle"
                maxlength="35"
                placeholder="请输入文件标题"
                style="width: 210px"
              />
              <!-- :disabled="editor == '1' ? true : false" -->
            </el-form-item>
            <el-form-item label-width="20px">
              <el-radio v-model="pxParmas.videoState" label="0">上架</el-radio>
              <el-radio v-model="pxParmas.videoState" label="1">下架</el-radio>
            </el-form-item>
          </div>
  
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="文件上传" label-width="80px" class="t-c">
              <uploadListFile
                :limit="limit"
                @fileList="videoFileClick"
                @moveList="moveClick"
                :fileList="videoFileList"
              >
              </uploadListFile>
            </el-form-item>
          </div>
  
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="所属分类" label-width="80px">
              <el-select
                v-model="pxParmas.catId"
                placeholder="请选择文件分类"
                @change="(val) => partChangeType(val)"
                filterable
                allow-create
                default-first-option
              >
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.catName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start" v-show="pxParmas.catId !== ''">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="所属部门" label-width="80px">
              <span>{{ organizationName }}</span>
            </el-form-item>
          </div>
          <el-form-item
            label="扩展部门"
            label-width="80px"
            v-show="pxParmas.catId !== '' && checkedCities.length !== 0"
          >
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(item, index) in partList" :label="item.id" disabled>{{
                item.organizationName
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
  
          <div class="dis-flex flex-x-start flex-y-start">
            <div class="dis-flex flex-x-start flex-y-start">
              <el-form-item label="考核形式" label-width="80px" class="t-c">
                <el-input
                  v-model="pxParmas.pxCheck"
                  maxlength="35"
                  placeholder="如:线下试卷/小程序答题..."
                  style="width: 210px"
                />
              </el-form-item>
            </div>
            <div class="dis-flex flex-x-start flex-y-start">
              <el-form-item label="培训老师" label-width="80px" class="t-c">
                <el-input
                  v-model="pxParmas.pxName"
                  maxlength="35"
                  placeholder="请输入培训老师"
                  style="width: 210px"
                />
              </el-form-item>
            </div>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <div class="dis-flex flex-x-start flex-y-start">
              <el-form-item label="培训形式" label-width="80px" class="t-c">
                <el-input
                  v-model="pxParmas.pxType"
                  maxlength="35"
                  placeholder="如:面授/自学..."
                  style="width: 210px"
                />
              </el-form-item>
            </div>
            <div class="dis-flex flex-x-start flex-y-start">
              <el-form-item label="培训时间" label-width="80px" class="t-c">
                <el-date-picker
                  v-model.trim="pxParmas.pxTime"
                  type="date"
                  placeholder="选择培训时间"
                  value-format="yyyy-MM-dd"
                  @change="selectTime"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="dis-flex flex-x-start flex-y-start">
            <el-form-item label="文件描述" label-width="80px">
              <textarea
                id="content"
                name="content"
                rows="6"
                cols="40"
                style="width: 100%; border: 1px solid #58e3e8"
                v-model="pxParmas.videoInfo"
              ></textarea>
            </el-form-item>
          </div>
        </el-form>
      </GDialog>
      <!--  新增/编辑分类e -->
    </section>
  </template>
  
  <script>
  // import Tinymce from "./tinymce";
  import uploadListFile from "@/components/Upload/uploadListFile.vue";
  import {
    bxUser,
    addPxNotice,
    queryPxNotice,
    updatePxNotice,
    queryPxVideoPagepx,
    updatePxVideo,
    delPxVideo,
    // queryPxCat,
    mp4ToJpg,
    importglYewugz,
    exportDeptStduyUserInfo,
    queryPxCatPagepx,
    selectMinDcDept,
    addPxVideopx,
    updatePxVideopx,
    delPxVideopx
  } from "@api/bx/api_contentManagement";
  import { parseTime } from "@utils/filters";
  export default {
    components: { uploadListFile },
    data() {
      return {
        tiny: {
          value: undefined,
        },
        scoreDialog: {
          title: "导出操作",
          visible: false,
        },
        themeDialog: {
          title: "信息框",
          visible: false,
        },
        themeDialogs: {
          title: "信息框",
          visible: false,
        },
        catDialog: {
          title: "信息框",
          visible: false,
        },
        searchForm: {
            page: 1,
                size: 10,
                videoState:'1'
        },
        total: 0,
        tableData: [],
        typeList: [],
        partList: [],
        dicCode: null,
        addCode: null,
        addItem: {},
        dicName: "",
        isEditor: false,
        editorRow: {},
        text: "",
        dishList: [],
        dayTime: "",
        video: "",
        jsonData: [],
        importData: [],
        title: "",
        item: {},
        pxParmas: {
          videoTitle: "",
          videoInfo: "",
          organizationId: "",
          organizationIds: "",
          catId: "",
          videoUrl: "",
          videoState: "0",
          pxCheck: "",
          pxName: "",
          pxTime: "",
          pxType: "",
        },
        editor: "0",
        radio: "0",
        partName: "",
        limit: 1,
        videoFileList: [],
        rootPath: "",
        organizationName: "",
        checkedCities: [],
        dayTime: "",
        id: "",
  
        // showVideo:false
      };
    },
    created() {
      this.selectMinDcDept();
      this.queryPxCatPagepx();
      this.queryPxVideoPagepx();
      // this.rootPath =
      //   "http://food.binsis.com/upload/file/20260920/c8f5fffe228f4d34a07a937ba147d717.pdf";
  
      // const response = { name: "pdf.pdf", url: this.rootPath, id: '', uid: '' }
      // this.videoFileList.push(response)
    },
    methods: {
      //多部门列表
      selectMinDcDept() {
        selectMinDcDept({}).then((res) => {
          this.partList = res;
        });
      },
      handleCheckedCitiesChange(val) {
        console.log(val);
      },
      moveClick(msg) {
        console.log(msg);
        // this.videoFileList=[{url:''}]
        this.pxParmas.videoUrl = "";
        // this.rootPath=''
      },
      catSubmitThemeForm() {
        console.log(this.pxParmas.videoUrl);
      },
      videoFileClick(msg) {
        this.pxParmas.videoUrl = msg[0].url;
      },
      // 视频分类筛选
      queryPxCatPagepx() {
        queryPxCatPagepx({
          page: 1,
          size: 1000,
        }).then((res) => {
          this.typeList = res.records;
        });
      },
      partChangeType() {
        this.typeList.map((item, index) => {
          if (this.pxParmas.catId == item.id) {
            // console.log(this.catId)
            this.organizationName = item.organizationName;
            this.pxParmas.organizationId = item.organizationId;
            if (item.organizationIds !== "") {
              this.checkedCities = item.organizationIds.split(",").map(Number);
            } else {
              this.checkedCities = [];
            }
          }
        });
      },
  
      uploadFormClick(item) {
        this.item = item;
        exportDeptStduyUserInfo({ videoId: item.id }).then((res) => {
          this.importData = res;
          this.scoreDialog.visible = true;
        });
      },
      down() {
        this.jsonData = [];
        this.$message.success("努力导出中");
        for (var i of this.importData) {
          this.jsonData.push({
            部门名称: i.organizationName,
            姓名: i.userName,
            分类名称: i.catName,
            培训主题: i.videoName,
            完成状态: i.stuat,
            完成时间: i.createTime,
          });
        }
        this.scoreDialog.visible = false;
      },
      cancelData() {
        this.searchForm.page = 1;
        this.searchForm.size = 10;
        this.searchForm.videoState = "0";
        this.searchForm.videoTitle = "";
        this.searchForm.catId = "";
        this.searchForm.beginTime = "";
        this.searchForm.endTime = "";
        this.dayTime = [];
        this.queryPxVideoPagepx();
      },
      handleClearType() {
        this.searchForm.catId = "";
        this.queryPxVideoPagepx();
      },
      selectTime(val) {
        // this.dayTime = [parseTime(res[0], "{y}-{m}-{d}"), parseTime(res[1], "{y}-{m}-{d}")];
        // console.log(this.dayTime[0])
        // console.log(this.dayTime[1])
        // this.searchForm.beginTime = parseTime(res[0], "{y}-{m}-{d}");
        // this.searchForm.endTime = parseTime(res[1], "{y}-{m}-{d}");
        //列表时间筛选
        if (val == null) {
          this.pxParmas.pxTime = "";
        } else {
          this.pxParmas.pxTime = val;
        }
      },
      // changeType(res) {
      //     console.log(this.dishName)
      // },
      //查看二维码
      showVideo(row) {
        this.video = row.videoUrl;
        this.themeDialogs.visible = true;
        // createDockorTitket({userId:row.userId}).then(res => {
        //     this.image = res
        // })
      },
      addVideo() {
        this.editor = "0";
        this.catDialog.visible = true;
      },
      // 保存富文本内容-保存字符串
      add() {
        const params = `this.tiny?.value`;
      },
      edit() {
        // 接口回显保存html
        // this.tiny.value = res.data|| ''
      },
  
      buttonClick() {
        //首次提交
        //     addPxNotice({
        //         noticeTitle: '测试',
        //         noticeContent:this.tiny.value,
        //         noticeImg:''
  
        //  }).then(res => {
        //             this.$message.success('上传成功')
  
        //         })
        //编辑提交
        updatePxNotice({
          noticeTitle: "编辑测试",
          noticeContent: this.tiny.value,
          id: 836,
          noticeImg: "",
        }).then((res) => {
          this.$message.success("上传成功");
        });
        // console.log(this.tiny.value)
      },
      //文章复现
      queryPxNotice() {
        // console.log(localStorage.getItem('userId').data)
        // return
        queryPxNotice({
          // userId: localStorage.getItem('userId').data,
        }).then((res) => {
          console.log(res);
          // this.$message.success('上传成功')
          // this.bxUser()
          this.tiny.value = res[1].noticeContent;
        });
        console.log(this.tiny.value);
      },
  
      tabHeader() {
        return "backgroundColor:rgba(88, 227, 232, 0.12);color:#000;font-weight:bold;font-size:15px;text-align: center;";
      },
      // // 视频分类筛选
      // queryPxCat() {
      //   queryPxCat({}).then((res) => {
      //     this.dishList = res;
      //     // this.total = res.total
      //   });
      // },
  
      // 视频列表
      queryPxVideoPagepx() {
        queryPxVideoPagepx(this.searchForm).then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        });
      },
  
      //下架
      updatePxVideo(row) {
        this.$confirm("是否重新上架【"+row.videoTitle+"】文件?", "提示", {
          confirmButtonText: "上架",
          cancelButtonText: "关闭",
          type: "warning",
        }).then(() => {
          updatePxVideopx({
            id: row.id,
            videoState: "0",
          }).then((res) => {
            this.$message.success("上架成功");
            this.queryPxVideoPagepx();
          });
        });
      },
  
      //解绑
      editorClick(row) {
        // console.log(row);
        this.editor = "1";
        // this.checkedCities = row.organizationIds = ""
        //   ? []
        //   : row.organizationIds.split(",").map(Number);
  
        this.pxParmas.videoTitle = row.videoTitle;
        this.pxParmas.videoInfo = row.videoInfo;
        this.pxParmas.catId = row.catId;
        this.pxParmas.organizationId = row.organizationId;
        // this.pxParmas.organizationIds = row.organizationIds;
  
        this.pxParmas.videoUrl = row.videoUrl;
        this.pxParmas.videoState = row.videoState;
        this.pxParmas.pxCheck = row.pxCheck;
        this.pxParmas.pxName = row.pxName;
        this.pxParmas.pxTime = row.pxTime;
        this.pxParmas.pxType = row.pxType;
  
        this.id = row.id;
        const response = { name: "pdf.pdf", url: row.videoUrl, id: "", uid: "" };
        this.videoFileList.push(response);
  
        this.partChangeType();
        this.catDialog.visible = true;
      },
      //表格删除
      delteFormClick(row) {
        this.$confirm("永久删除" + "这条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          delPxVideopx({ id: row.id }).then((res) => {
            this.queryPxVideoPagepx();
          });
        });
      },
  
      catresetThemeForm() {
        this.editor = "0";
        this.checkedCities = [];
        this.pxParmas.videoTitle = "";
        this.pxParmas.videoInfo = "";
        this.pxParmas.catId = "";
        this.organizationName = "";
        this.pxParmas.organizationId = "";
        this.pxParmas.organizationIds = "";
  
        this.pxParmas.videoUrl = "";
        this.pxParmas.videoState = "0";
        this.pxParmas.pxCheck = "";
        this.pxParmas.pxName = "";
        this.pxParmas.pxTime = "";
        this.pxParmas.pxType = "";
  
        this.id = "";
        this.videoFileList = [];
        this.catDialog.visible = false;
      },
  
      //分类新增,编辑
      catSubmitThemeForm() {
        if (this.pxParmas.videoTitle == "") {
          this.$message.warning("请输入文件标题");
          return;
        }
        if (this.pxParmas.videoUrl == "") {
          this.$message.warning("请上传培训文件");
          return;
        }
        if (this.pxParmas.catId == "") {
          this.$message.warning("请选择文件分类");
          return;
        }
        if (this.editor == "0") {
          //首次提交
          addPxVideopx({
            videoTitle: this.pxParmas.videoTitle,
            videoInfo: this.pxParmas.videoInfo,
            organizationId: this.pxParmas.organizationId,
            organizationIds:
              this.checkedCities.length !== 0 ? this.checkedCities.join() : "",
            catId: this.pxParmas.catId,
            videoUrl: this.pxParmas.videoUrl,
            videoState: this.pxParmas.videoState,
            pxCheck: this.pxParmas.pxCheck,
            pxName: this.pxParmas.pxName,
            pxTime: this.pxParmas.pxTime,
            pxType: this.pxParmas.pxType,
          }).then((res) => {
            this.$message.success("上传文件成功");
            this.catresetThemeForm();
            this.queryPxVideoPagepx();
          });
        } else {
          //编辑提交
          updatePxVideopx({
            videoTitle: this.pxParmas.videoTitle,
            videoInfo: this.pxParmas.videoInfo,
            organizationId: this.pxParmas.organizationId,
            organizationIds:
              this.checkedCities.length !== 0 ? this.checkedCities.join() : "",
            catId: this.pxParmas.catId,
            videoUrl: this.pxParmas.videoUrl,
            videoState: this.pxParmas.videoState,
            pxCheck: this.pxParmas.pxCheck,
            pxName: this.pxParmas.pxName,
            pxTime: this.pxParmas.pxTime,
            pxType: this.pxParmas.pxType,
            id: this.id,
          }).then((res) => {
            this.$message.success("编辑文件成功");
            this.catresetThemeForm();
            this.queryPxVideoPagepx();
          });
        }
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  /* .tree /deep/ .el-tree-node__content{
          padding-left: 40px
      } */
  .turnBule {
    color: #fff;
    background-color: #58e3e8;
    border-color: rgba(56, 185, 190, 0.12);
    margin-left: 15px;
  }
  
  .turnBule:hover,
  .turnBule:focus {
    background: rgba(56, 185, 190, 0.5);
    border-color: rgba(56, 185, 190, 0.5);
    color: #fff;
  }
  
  .el-button--text.reviewed {
    color: #38b9be;
  }
  
  .reviewed {
    color: #38b9be;
  }
  
  .el-tree-node__content {
    z-index: 999;
    padding-left: 40px;
  }
  
  .directory-in {
    width: 32%;
    line-height: 60px;
    background: #4095e5;
  }
  </style>
  